import { get } from 'lodash'
import React from 'react'
import styled from 'styled-components'
import { FaTrash } from 'react-icons/fa'

import { NumberInput, SearchSelect } from '../../../../../input'
import { FONTS } from '../../../../../../constants'
import { getInvoicedBillingType, getAllocationByBillingType } from '../../../../../../function/billing'
import { percentage } from '../../../../../../function/math'

export const ListDetail = ({
  detailState,
  handleListsDetails,
  handleRemoveDetail,
  revenueAllocation,
  billings,
  interpretBillingType,
}) => {
  const { billing_types = [] } = detailState
  return (
    <ListWrapper>
      <HeaderText>Lists Details</HeaderText>
      {billing_types.map((d, key) => {
        const _type = d.type ? interpretBillingType.find(t => t.label === d.label) : null
        const billingPrice = d.price
        const selectAllocation = getAllocationByBillingType(revenueAllocation, d)
        const invoicedBillingType = getInvoicedBillingType(billings, d)
        return (
          <ListRow key={ key }>
            <FlexCol flex={ 3 }>
              <FlexRow>
                <FlexCol flex={ 1 }>
                  <Title>Type</Title>
                  <SearchSelect
                    placeholder='Select Type'
                    options={ interpretBillingType }
                    value={ _type }
                    invalid={ !_type }
                    onChange={ e => {
                      handleListsDetails(e, 'type', key)
                      // handleListsDetails(e.label, 'label', key)
                      // handleListsDetails(e.cr_id, 'cr_id', key)
                      // handleListsDetails(e.product_id, 'product_id', key)
                    } }
                  />
                </FlexCol>
                <FlexCol flex={ 1 } margin='0 12px'>
                  <Title>Value</Title>
                  <NumberInput
                    prefix='฿'
                    allowEmptyFormatting={ true }
                    thousandSeparator={ true }
                    decimalScale={ 2 }
                    fixedDecimalScale={ true }
                    placeholder='Enter Price'
                    invalid={ +detailState.billing_types[key].price === 0 }
                    value={ detailState.billing_types[key].price || 0 }
                    onChange={ e => handleListsDetails(e.target.value, 'price', key) }
                  />
                </FlexCol>
              </FlexRow>
              <FlexRow>
                <FlexCol>
                  <Title>Planned Revenue:</Title>
                  <Text>{`฿ ${get(selectAllocation, 'revenue', '0.00')}`}</Text>
                </FlexCol>
                <FlexCol margin='0 0 0 24px'>
                  <Title>Already Planned:</Title>
                  <Text>{`฿ ${invoicedBillingType}`}</Text>
                </FlexCol>
              </FlexRow>
            </FlexCol>
            <FlexCol flex={ 1 }>
              <Title>LOB Allocate</Title>
              <FlexCol>
                {selectAllocation && selectAllocation.lobs.map(l => (
                  <DetailRow key={ l.lob_id }>
                    <AllocationTextWrapper>
                      <AllocationText>{`${l._lob_name}: ${l.lob_percent}%`}</AllocationText>
                    </AllocationTextWrapper>
                    <AllocationTextWrapper>
                      <AllocationText>{billingPrice ? `฿${percentage(billingPrice, l.lob_percent)}` : '-'}</AllocationText>
                    </AllocationTextWrapper>
                  </DetailRow>
                ))}
              </FlexCol>
            </FlexCol>
            <TrashWrapper>
              <Trash onClick={ () => handleRemoveDetail(key) } />
            </TrashWrapper>
          </ListRow>
        )
      })}
    </ListWrapper>
  )
}

const Row = styled.div`
  display: flex;
`

const FlexRow = styled(Row)`
  margin-bottom: 16px;
  ${p => p.flex && `flex: ${p.flex}`}
`

const DetailRow = styled(Row)`
  margin: 8px 0;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

const FlexCol = styled(Col)`
  margin: ${p => p.margin};
  ${p => p.flex && `flex: ${p.flex}`}
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ListRow = styled.div`
  height: 100%;
  display: flex;
  background: #F9F9F9;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
`

const TrashWrapper = styled.div`
  width: 30px;
  height: 100%;
  margin-top: 24px;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
  margin-bottom: 12px;
`

const Text = styled.span`
  font-family: NotoSans;
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const AllocationTextWrapper = styled.div`
  min-width: 150px;
`

const AllocationText = styled.span`
  font-family: NotoSans;
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
`

const Trash = styled(FaTrash)`
  font-size: 16px;
  color: #C4C4C4;
  cursor: pointer;

  :hover {
    color: #D44B49;
  }
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/create-billing/list-detail/index.js